import React from "react";

export default function Wallet() {
  return (
    <div className="main contact-page">
      <div className="section section-gray">
        <div className="container">
          <div className="row">
            <div>Wallet</div>
          </div>
        </div>
      </div>
    </div>
  );
}
